import { AbstractControl } from '@angular/forms';

export function getFilesFromControl(control: AbstractControl): File[] {
	const files: File[] = control.value;

	if (!(files || []).length || !files.every((file) => file instanceof File)) {
		return null;
	}

	return files;
}
